import {
  Box,
  Stack
} from '@mui/material';
import {
  ExternalFolderDetailSection,
  ExternalFolderHeaderSection
} from 'modules';
import { useParams } from 'react-router-dom';

import imgLogo from 'assets/logo/logoFull.png';



export type FolderActivityProps = {};

export const FolderActivity = () => {
  const { folderId } = useParams();

  return (
    <Stack
      gap={1}
      sx={{
        padding: '1rem'
      }}
    >
      <Box
        component='img'
        sx={{
          height: '100px',
          objectFit: 'contain'
        }}
        src={imgLogo}
      />
      <ExternalFolderHeaderSection.FC folderId={folderId ?? ''} />
      <ExternalFolderDetailSection.FC folderId={folderId ?? ''} />
    </Stack>
  );
};
